import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0b980fa9")

_pushScopeId("data-v-0b980fa9")
const _hoisted_1 = { class: "launchpadContainer gt-sm" }
const _hoisted_2 = { class: "homeContainer gt-sm" }
const _hoisted_3 = { class: "home" }
const _hoisted_4 = { class: "asset-list" }
const _hoisted_5 = { class: "tabs" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "tab-texture" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { style: {"padding-left":"8px"} }, "LARIX", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "tab-texture" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { style: {"padding-left":"8px"} }, "Stepn", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "tab-texture" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { style: {"padding-left":"8px"} }, "Step", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "tab-texture" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { style: {"padding-left":"8px"} }, "xSOL", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "tab-bg tab-bonfidaImg" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "tab-texture" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { style: {"padding-left":"8px"} }, "Bonfida", -1)
const _hoisted_17 = { class: "assets" }
const _hoisted_18 = { style: {"width":"100%"} }
const _hoisted_19 = { style: {"width":"100%"} }
const _hoisted_20 = { style: {"width":"9%"} }
const _hoisted_21 = { style: {"text-align":"left"} }
const _hoisted_22 = { style: {"width":"17.5%"} }
const _hoisted_23 = { style: {"text-align":"right"} }
const _hoisted_24 = { style: {"font-size":"14px","margin-bottom":"0"} }
const _hoisted_25 = { style: {"width":"17.5%"} }
const _hoisted_26 = { style: {"text-align":"right"} }
const _hoisted_27 = { style: {"font-size":"14px","margin-bottom":"0"} }
const _hoisted_28 = { style: {"width":"17.5%"} }
const _hoisted_29 = { style: {"text-align":"right"} }
const _hoisted_30 = { style: {"font-size":"14px","margin-bottom":"0"} }
const _hoisted_31 = { style: {"width":"17.5%"} }
const _hoisted_32 = { style: {"text-align":"right"} }
const _hoisted_33 = { style: {"font-size":"14px","margin-bottom":"0"} }
const _hoisted_34 = { style: {"width":"17.5%"} }
const _hoisted_35 = { style: {"width":"9%"} }
const _hoisted_36 = { class: "token-cell" }
const _hoisted_37 = { class: "token-img" }
const _hoisted_38 = { class: "text-wrap" }
const _hoisted_39 = { style: {"font-size":"16px","margin-bottom":"4px"} }
const _hoisted_40 = {
  class: "grey-color",
  style: {"line-height":"18px"}
}
const _hoisted_41 = { style: {"width":"17.5%"} }
const _hoisted_42 = { class: "apr-cell" }
const _hoisted_43 = { style: {"font-size":"16px","margin-bottom":"2px"} }
const _hoisted_44 = { class: "grey-color apr-details-wrap" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 2 }
const _hoisted_48 = { style: {"width":"17.5%"} }
const _hoisted_49 = { class: "apr-cell" }
const _hoisted_50 = { style: {"font-size":"16px","margin-bottom":"2px"} }
const _hoisted_51 = { class: "grey-color apr-details-wrap" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { key: 2 }
const _hoisted_55 = { style: {"width":"17.5%"} }
const _hoisted_56 = { class: "data-cell" }
const _hoisted_57 = { style: {"font-size":"16px","margin-bottom":"2px","white-space":"nowrap"} }
const _hoisted_58 = { class: "grey-color details-wrap" }
const _hoisted_59 = { style: {"width":"17.5%"} }
const _hoisted_60 = { class: "data-cell" }
const _hoisted_61 = { style: {"font-size":"16px","margin-bottom":"2px","white-space":"nowrap"} }
const _hoisted_62 = { class: "grey-color details-wrap" }
const _hoisted_63 = { class: "action-cell" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { style: {"width":"9%"} }
const _hoisted_66 = { class: "token-cell" }
const _hoisted_67 = { class: "token-img" }
const _hoisted_68 = { lass: "text-wrap" }
const _hoisted_69 = { style: {"width":"17.5%"} }
const _hoisted_70 = { class: "apr-cell" }
const _hoisted_71 = { class: "grey-color apr-details-wrap" }
const _hoisted_72 = { style: {"width":"17.5%"} }
const _hoisted_73 = { class: "apr-cell" }
const _hoisted_74 = { class: "grey-color apr-details-wrap" }
const _hoisted_75 = { style: {"width":"17.5%"} }
const _hoisted_76 = { class: "apr-cell" }
const _hoisted_77 = { class: "grey-color apr-details-wrap" }
const _hoisted_78 = { style: {"width":"17.5%"} }
const _hoisted_79 = { class: "apr-cell" }
const _hoisted_80 = { class: "grey-color apr-details-wrap" }
const _hoisted_81 = { style: {"width":"17.5%"} }
const _hoisted_82 = { class: "action-cell" }
const _hoisted_83 = { class: "launchpadContainerApp lt-md" }
const _hoisted_84 = { class: "homeAppContainer lt-md" }
const _hoisted_85 = { class: "homeAppContainer-table" }
const _hoisted_86 = { class: "asset-list" }
const _hoisted_87 = { class: "tabs" }
const _hoisted_88 = {
  class: "no-fee-tip",
  style: {"min-width":"120px"}
}
const _hoisted_89 = /*#__PURE__*/_createVNode("div", { style: {"border-left":"1px solid #A1B7EE","height":"10px"} }, null, -1)
const _hoisted_90 = { key: 0 }
const _hoisted_91 = { class: "homeAppContainer-table-item-title" }
const _hoisted_92 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = { style: {"color":"#9CB7F3","font-size":"12px"} }
const _hoisted_95 = { key: 1 }
const _hoisted_96 = /*#__PURE__*/_createVNode("span", { style: {"color":"#9CB7F3","font-size":"12px"} }, "Raydium", -1)
const _hoisted_97 = { style: {"text-align":"right"} }
const _hoisted_98 = { style: {"color":"#9CB7F3","font-size":"12px"} }
const _hoisted_99 = { class: "homeAppContainer-table-item-main" }
const _hoisted_100 = { style: {"color":"#9CB7F3","font-size":"12px"} }
const _hoisted_101 = { style: {"white-space":"nowrap"} }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 0 }
const _hoisted_104 = { key: 1 }
const _hoisted_105 = { key: 2 }
const _hoisted_106 = { key: 3 }
const _hoisted_107 = { key: 0 }
const _hoisted_108 = { key: 1 }
const _hoisted_109 = {
  key: 0,
  class: "homeAppContainer-table-item-main"
}
const _hoisted_110 = { style: {"color":"#9CB7F3","font-size":"12px"} }
const _hoisted_111 = { style: {"white-space":"nowrap"} }
const _hoisted_112 = { key: 0 }
const _hoisted_113 = { key: 1 }
const _hoisted_114 = { class: "homeAppContainer-table-item-main" }
const _hoisted_115 = { style: {"color":"#9CB7F3","font-size":"12px"} }
const _hoisted_116 = { class: "homeAppContainer-table-item-button" }
const _hoisted_117 = {
  key: 1,
  class: "homeAppContainer-table-item"
}
const _hoisted_118 = { class: "homeAppContainer-table-item-title" }
const _hoisted_119 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_120 = { style: {"position":"relative"} }
const _hoisted_121 = { class: "homeAppContainer-table-item-main" }
const _hoisted_122 = { style: {"color":"#9CB7F3","font-size":"12px"} }
const _hoisted_123 = { class: "homeAppContainer-table-item-main" }
const _hoisted_124 = { style: {"color":"#9CB7F3","font-size":"12px"} }
const _hoisted_125 = { class: "homeAppContainer-table-item-main" }
const _hoisted_126 = { style: {"color":"#9CB7F3","font-size":"12px"} }
const _hoisted_127 = { class: "homeAppContainer-table-item-button" }
const _hoisted_128 = /*#__PURE__*/_createVNode("div", {
  class: "link",
  style: {"width":"calc(100% - 165px)"}
}, null, -1)
const _hoisted_129 = { style: {"width":"165px","display":"flex"} }
const _hoisted_130 = /*#__PURE__*/_createVNode("div", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SupplyDialog = _resolveComponent("SupplyDialog")
  const _component_q_dialog = _resolveComponent("q-dialog")
  const _component_BorrowDialog = _resolveComponent("BorrowDialog")
  const _component_SupplyAndBorrow = _resolveComponent("SupplyAndBorrow")
  const _component_q_tooltip = _resolveComponent("q-tooltip")
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_skeleton = _resolveComponent("q-skeleton")
  const _component_q_icon = _resolveComponent("q-icon")
  const _component_q_page_scroller = _resolveComponent("q-page-scroller")
  const _component_q_layout = _resolveComponent("q-layout")
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.$store.state.dialog.supplyDialogVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$store.state.dialog.supplyDialogVisible = $event))
    }, {
      default: _withId(() => [
        (_ctx.$store.state.dialog.supplyDialogVisible)
          ? (_openBlock(), _createBlock(_component_SupplyDialog, {
              key: 0,
              "enable-for": _ctx.enableFor,
              "selected-reserve-detail": _ctx.selectedReserveDetail,
              "user-obligation-index": _ctx.userObligationIndex,
              "pool-type": _ctx.selectedReserveDetail.poolType
            }, null, 8, ["enable-for", "selected-reserve-detail", "user-obligation-index", "pool-type"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.$store.state.dialog.borrowDialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$store.state.dialog.borrowDialogVisible = $event))
    }, {
      default: _withId(() => [
        (_ctx.$store.state.dialog.borrowDialogVisible)
          ? (_openBlock(), _createBlock(_component_BorrowDialog, {
              key: 0,
              "enable-for": _ctx.enableFor,
              "selected-reserve-detail": _ctx.selectedReserveDetail,
              "user-obligation-index": _ctx.userObligationIndex,
              "pool-type": _ctx.selectedReserveDetail.poolType
            }, null, 8, ["enable-for", "selected-reserve-detail", "user-obligation-index", "pool-type"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_q_layout, null, {
          default: _withId(() => [
            _createVNode(_component_SupplyAndBorrow, {
              "pool-type": _ctx.poolType,
              "page-type": "Home"
            }, null, 8, ["pool-type"]),
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", {
                    class: ["tab", _ctx.poolType==='larix'?'tab-btnBg':'tab-btnNormal'],
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.poolType='larix'))
                  }, [
                    _createVNode("div", {
                      class: ["tab-icon", _ctx.poolType==='larix'?'':'tab-icon-normal']
                    }, null, 2),
                    _createVNode("div", {
                      class: ["tab-bg", _ctx.poolType==='larix'?'tab-larixPressImg':'tab-larixNormalImg']
                    }, null, 2),
                    _hoisted_6,
                    _hoisted_7
                  ], 2),
                  _createVNode("div", {
                    class: ["tab", _ctx.poolType==='stepn'?'tab-btnBg':'tab-btnNormal'],
                    style: {"margin-left":"8px"},
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.poolType='stepn'))
                  }, [
                    _createVNode("div", {
                      class: ["tab-icon", _ctx.poolType==='stepn'?'':'tab-icon-normal']
                    }, null, 2),
                    _createVNode("div", {
                      class: ["tab-bg", _ctx.poolType==='stepn'?'tab-stepnPressImg':'tab-stepnNormalImg']
                    }, null, 2),
                    _hoisted_8,
                    _hoisted_9
                  ], 2),
                  _createVNode("div", {
                    class: ["tab", _ctx.poolType==='step'?'tab-btnBg':'tab-btnNormal'],
                    style: {"margin-left":"8px"},
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.poolType='step'))
                  }, [
                    _createVNode("div", {
                      class: ["tab-icon", _ctx.poolType==='step'?'':'tab-icon-normal']
                    }, null, 2),
                    _createVNode("div", {
                      class: ["tab-bg", _ctx.poolType==='step'?'tab-stepPressImg':'tab-stepNormalImg']
                    }, null, 2),
                    _hoisted_10,
                    _hoisted_11
                  ], 2),
                  _createVNode("div", {
                    class: ["tab", _ctx.poolType==='xSol'?'tab-btnBg':'tab-btnNormal'],
                    style: {"margin-left":"8px"},
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.poolType='xSol'))
                  }, [
                    _createVNode("div", {
                      class: ["tab-icon", _ctx.poolType==='xSol'?'':'tab-icon-normal']
                    }, null, 2),
                    _createVNode("div", {
                      class: ["tab-bg", _ctx.poolType==='xSol'?'tab-xSolPressImg':'tab-xSolNormalImg']
                    }, null, 2),
                    _hoisted_12,
                    _hoisted_13
                  ], 2),
                  _createVNode("div", {
                    class: ["tab", _ctx.poolType==='bonfida'?'tab-btnBg':'tab-btnNormal'],
                    style: {"margin-left":"8px"},
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.poolType='bonfida'))
                  }, [
                    _createVNode("div", {
                      class: ["tab-icon", _ctx.poolType==='bonfida'?'':'tab-icon-normal']
                    }, null, 2),
                    _hoisted_14,
                    _hoisted_15,
                    _hoisted_16
                  ], 2)
                ])
              ]),
              _createVNode("div", _hoisted_17, [
                _createVNode("table", _hoisted_18, [
                  _createVNode("tr", _hoisted_19, [
                    _createVNode("th", _hoisted_20, [
                      _createVNode("div", _hoisted_21, _toDisplayString(_ctx.t('home.asset')), 1)
                    ]),
                    _createVNode("th", _hoisted_22, [
                      _createVNode("div", _hoisted_23, [
                        _createTextVNode(_toDisplayString(_ctx.t('home.supplyAPY')) + " ", 1),
                        _createVNode("img", {
                          src: _ctx.icon_information,
                          height: "14",
                          width: "14",
                          style: {"cursor":"pointer","position":"relative","top":"2px"}
                        }, null, 8, ["src"]),
                        _createVNode(_component_q_tooltip, {
                          anchor: "center right",
                          self: "center left"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_24, _toDisplayString(_ctx.t('tip.supplyAPRTip')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode("th", _hoisted_25, [
                      _createVNode("div", _hoisted_26, [
                        _createTextVNode(_toDisplayString(_ctx.t('home.borrowAPY')) + " ", 1),
                        _createVNode("img", {
                          src: _ctx.icon_information,
                          height: "14",
                          width: "14",
                          style: {"cursor":"pointer","position":"relative","top":"2px"}
                        }, null, 8, ["src"]),
                        _createVNode(_component_q_tooltip, {
                          anchor: "center right",
                          self: "center left"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_27, _toDisplayString(_ctx.t('tip.borrowAPRTip')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode("th", _hoisted_28, [
                      _createVNode("div", _hoisted_29, [
                        _createTextVNode(_toDisplayString(_ctx.t('home.wallet')) + " ", 1),
                        _createVNode("img", {
                          src: _ctx.icon_information,
                          height: "14",
                          width: "14",
                          style: {"cursor":"pointer","position":"relative","top":"2px"}
                        }, null, 8, ["src"]),
                        _createVNode(_component_q_tooltip, {
                          anchor: "center right",
                          self: "center left"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_30, _toDisplayString(_ctx.t('tip.walletBalanceTip')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode("th", _hoisted_31, [
                      _createVNode("div", _hoisted_32, [
                        _createTextVNode(_toDisplayString(_ctx.t('home.liquidity')) + " ", 1),
                        _createVNode("img", {
                          src: _ctx.icon_information,
                          height: "14",
                          width: "14",
                          style: {"cursor":"pointer","position":"relative","top":"2px"}
                        }, null, 8, ["src"]),
                        _createVNode(_component_q_tooltip, {
                          anchor: "center right",
                          self: "center left"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_33, _toDisplayString(_ctx.t('tip.liquidityTip')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode("th", _hoisted_34, [
                      _createVNode("span", null, _toDisplayString(_ctx.t('home.operation')), 1)
                    ])
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortMarket(), (item) => {
                    return (_openBlock(), _createBlock("tr", {
                      key: item.id
                    }, [
                      _createVNode("td", _hoisted_35, [
                        _createVNode("div", _hoisted_36, [
                          _createVNode("div", _hoisted_37, [
                            _createVNode("img", {
                              src: item.logoSource,
                              width: "38",
                              height: "38"
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("div", _hoisted_38, [
                            _createVNode("div", _hoisted_39, _toDisplayString(item.symbol), 1),
                            _createVNode("div", _hoisted_40, "$" + _toDisplayString(item.liquidityPrice.toFixed(2)), 1)
                          ])
                        ])
                      ]),
                      _createVNode("td", _hoisted_41, [
                        _createVNode("div", _hoisted_42, [
                          _createVNode("div", _hoisted_43, _toDisplayString(_ctx.formatBigNumberStr(item.supplyApy.times(100).plus( item.supplyDistributionApy.times(100)).plus(item.singleTokenDoubleRewardApy.times(100)),2)) + "% ", 1),
                          _createVNode("div", _hoisted_44, [
                            _createVNode("span", null, _toDisplayString(_ctx.formatBigNumberStr(item.supplyApy.times(100),2)) + "% +", 1),
                            (item.supplyDistributionApy.isGreaterThan(0))
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: _ctx.larixLogo,
                                  width: "16",
                                  height: "16",
                                  style: {"border-radius":"50%","margin-left":"4px"}
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true),
                            (item.hasSingleTokenDoubleReward&&item.singleTokenDoubleRewardApy?.isGreaterThan(0))
                              ? (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  src: item.singleTokenDoubleRewardLogo,
                                  width: "16",
                                  height: "16",
                                  style: {"border-radius":"50%","margin-left":"4px"}
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true),
                            _createVNode("img", {
                              src: _ctx.icon_information,
                              width: "16",
                              height: "16",
                              style: {"margin-left":"4px","cursor":"pointer"}
                            }, null, 8, ["src"]),
                            (item.singleTokenDoubleRewardApy?.isGreaterThan(0)||item.supplyDistributionApy.isGreaterThan(0))
                              ? (_openBlock(), _createBlock(_component_q_tooltip, {
                                  key: 2,
                                  anchor: "top right",
                                  self: "bottom right",
                                  offset: [100,10]
                                }, {
                                  default: _withId(() => [
                                    (item.hasSingleTokenDoubleReward&&item.singleTokenDoubleRewardApy.isGreaterThan(0))
                                      ? (_openBlock(), _createBlock("p", _hoisted_45, "+ " + _toDisplayString(item.singleTokenDoubleRewardTokenSymbol) + " " + _toDisplayString(item.singleTokenDoubleRewardApy.times(100).toFixed(2)) + "%", 1))
                                      : _createCommentVNode("", true),
                                    (item.supplyDistributionApy.isGreaterThan(0))
                                      ? (_openBlock(), _createBlock("p", _hoisted_46, "+ " + _toDisplayString(_ctx.t('tip.larixRewards')) + " " + _toDisplayString(_ctx.formatBigNumberStr(item.supplyDistributionApy.times(100),2)) + "%", 1))
                                      : _createCommentVNode("", true),
                                    (item.singleTokenDoubleRewardTokenSymbol&&item.singleTokenDoubleRewardApy?.isGreaterThan(0))
                                      ? (_openBlock(), _createBlock("p", _hoisted_47, _toDisplayString(_ctx.t('tip.doubleRewardTip',{x:item.singleTokenDoubleRewardTokenSymbol})), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createVNode("td", _hoisted_48, [
                        _createVNode("div", _hoisted_49, [
                          _createVNode("div", _hoisted_50, _toDisplayString(_ctx.formatBigNumberStr(item.borrowApy.times(100).minus(item.borrowDistributionApy.times(100)).minus(item?.singleTokenDoubleBorrowRewardApy||0),2)) + "% ", 1),
                          _createVNode("div", _hoisted_51, [
                            _createVNode("span", null, _toDisplayString(item.borrowApy.times(100).toFixed(2)) + "% −", 1),
                            (item.borrowDistributionApy.isGreaterThan(0))
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: _ctx.larixLogo,
                                  width: "16",
                                  height: "16",
                                  style: {"border-radius":"50%","margin-left":"4px"}
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true),
                            (item.singleTokenDoubleRewardTokenSymbol&&item.singleTokenDoubleBorrowRewardApy?.isGreaterThan(0))
                              ? (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  width: "16",
                                  height: "16",
                                  src: item.singleTokenDoubleRewardLogo,
                                  style: {"margin-left":"4px"}
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true),
                            _createVNode("img", {
                              src: _ctx.icon_information,
                              width: "16",
                              height: "16",
                              style: {"margin-left":"4px","cursor":"pointer"}
                            }, null, 8, ["src"]),
                            (item.borrowDistributionApy.isGreaterThan(0)||item.singleTokenDoubleBorrowRewardApy?.isGreaterThan(0))
                              ? (_openBlock(), _createBlock(_component_q_tooltip, {
                                  key: 2,
                                  anchor: "top right",
                                  self: "bottom right",
                                  offset: [100,10]
                                }, {
                                  default: _withId(() => [
                                    (item.borrowDistributionApy.isGreaterThan(0))
                                      ? (_openBlock(), _createBlock("p", _hoisted_52, "- " + _toDisplayString(_ctx.t('tip.larixRewards')) + " " + _toDisplayString(_ctx.formatBigNumberStr(item.borrowDistributionApy.times(100),2)) + "%", 1))
                                      : _createCommentVNode("", true),
                                    (item.singleTokenDoubleBorrowRewardApy&&item.singleTokenDoubleBorrowRewardApy?.isGreaterThan(0))
                                      ? (_openBlock(), _createBlock("p", _hoisted_53, "- " + _toDisplayString(item.singleTokenDoubleRewardTokenSymbol) + " " + _toDisplayString(item.singleTokenDoubleBorrowRewardApy.toFixed(2)) + "%", 1))
                                      : _createCommentVNode("", true),
                                    (item.singleTokenDoubleRewardTokenSymbol&&item.singleTokenDoubleBorrowRewardApy?.isGreaterThan(0))
                                      ? (_openBlock(), _createBlock("p", _hoisted_54, _toDisplayString(_ctx.t('tip.doubleRewardTip',{x:item.singleTokenDoubleRewardTokenSymbol})), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createVNode("td", _hoisted_55, [
                        _createVNode("div", _hoisted_56, [
                          _createVNode("div", _hoisted_57, _toDisplayString(item.userAssetDetails? _ctx.formatBigNumberStr(item.userAssetDetails.walletBalanceInTokenUnit,['soETH','ETH','BTC'].includes(item.symbol)||item.isLP?4:2) :0) + " " + _toDisplayString(item.symbol), 1),
                          _createVNode("div", _hoisted_58, [
                            _createVNode("span", null, "$" + _toDisplayString(item.userAssetDetails? _ctx.formatBigNumberStr(item.userAssetDetails.walletBalanceInTokenUnit.times(item.liquidityPrice),['soETH','ETH','BTC'].includes(item.symbol)||item.isLP?4:2):0), 1)
                          ])
                        ])
                      ]),
                      _createVNode("td", _hoisted_59, [
                        _createVNode("div", _hoisted_60, [
                          _createVNode("div", _hoisted_61, _toDisplayString(_ctx.formatBigNumberStr(item.totalAvailableAmount,0)) + " " + _toDisplayString(item.symbol), 1),
                          _createVNode("div", _hoisted_62, [
                            _createVNode("span", null, "$" + _toDisplayString(_ctx.formatBigNumberStr(item.totalAvailableAmount.times(item.liquidityPrice),0)), 1)
                          ])
                        ])
                      ]),
                      _createVNode("td", null, [
                        _createVNode("div", _hoisted_63, [
                          _createVNode("div", {
                            class: "operationButton",
                            onClick: ($event: any) => (_ctx.openSupplyMarketsDialog(item,'supply'))
                          }, [
                            _createVNode("span", null, _toDisplayString(_ctx.t('home.supply')), 1)
                          ], 8, ["onClick"]),
                          _createVNode(_component_q_btn, {
                            class: "operationButton",
                            "no-caps": "",
                            style: {"min-height":"30px","height":"30px","font-weight":"400"},
                            onClick: ($event: any) => (_ctx.openBorrowMarketsDialog(item,'borrow'))
                          }, {
                            default: _withId(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('home.borrow')), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                (_ctx.isLoadingInfo&&_ctx.walletAddress!=='')
                  ? (_openBlock(), _createBlock("table", _hoisted_64, [
                      (_openBlock(), _createBlock(_Fragment, null, _renderList(4, (i) => {
                        return _createVNode("tr", {
                          key: i ,
                          style: {"opacity":"0.5"}
                        }, [
                          _createVNode("td", _hoisted_65, [
                            _createVNode("div", _hoisted_66, [
                              _createVNode("div", _hoisted_67, [
                                _createVNode(_component_q_skeleton, {
                                  type: "QAvatar",
                                  style: {"width":"38px","height":"38px"}
                                })
                              ]),
                              _createVNode("div", _hoisted_68, [
                                _createVNode(_component_q_skeleton, {
                                  type: "text",
                                  style: {"width":"42px","margin-bottom":"4px"}
                                }),
                                _createVNode(_component_q_skeleton, {
                                  type: "text",
                                  style: {"width":"34px","line-height":"18px"}
                                })
                              ])
                            ])
                          ]),
                          _createVNode("td", _hoisted_69, [
                            _createVNode("div", _hoisted_70, [
                              _createVNode("div", null, [
                                _createVNode(_component_q_skeleton, {
                                  type: "text",
                                  style: {"width":"54px","margin-bottom":"4px","position":"relative","float":"right"}
                                })
                              ]),
                              _createVNode("div", _hoisted_71, [
                                _createVNode(_component_q_skeleton, {
                                  type: "text",
                                  style: {"width":"54px","margin-bottom":"4px"}
                                }),
                                _createVNode(_component_q_skeleton, {
                                  type: "QAvatar",
                                  style: {"border-radius":"50%","margin-left":"4px","width":"16px","height":"16px"}
                                }),
                                _createVNode(_component_q_skeleton, {
                                  type: "QAvatar",
                                  style: {"border-radius":"50%","margin-left":"4px","width":"16px","height":"16px"}
                                }),
                                _createVNode(_component_q_skeleton, {
                                  type: "QAvatar",
                                  style: {"margin-left":"4px","width":"16px","height":"16px"}
                                })
                              ])
                            ])
                          ]),
                          _createVNode("td", _hoisted_72, [
                            _createVNode("div", _hoisted_73, [
                              _createVNode("div", null, [
                                _createVNode(_component_q_skeleton, {
                                  type: "text",
                                  style: {"width":"54px","margin-bottom":"4px","position":"relative","float":"right"}
                                })
                              ]),
                              _createVNode("div", _hoisted_74, [
                                _createVNode(_component_q_skeleton, {
                                  type: "text",
                                  style: {"width":"54px","margin-bottom":"4px"}
                                }),
                                _createVNode(_component_q_skeleton, {
                                  type: "QAvatar",
                                  style: {"border-radius":"50%","margin-left":"4px","width":"16px","height":"16px"}
                                }),
                                _createVNode(_component_q_skeleton, {
                                  type: "QAvatar",
                                  style: {"border-radius":"50%","margin-left":"4px","width":"16px","height":"16px"}
                                })
                              ])
                            ])
                          ]),
                          _createVNode("td", _hoisted_75, [
                            _createVNode("div", _hoisted_76, [
                              _createVNode("div", null, [
                                _createVNode(_component_q_skeleton, {
                                  type: "text",
                                  style: {"width":"78px","margin-bottom":"4px","position":"relative","float":"right"}
                                })
                              ]),
                              _createVNode("div", _hoisted_77, [
                                _createVNode(_component_q_skeleton, {
                                  type: "text",
                                  style: {"width":"34px","margin-bottom":"4px"}
                                })
                              ])
                            ])
                          ]),
                          _createVNode("td", _hoisted_78, [
                            _createVNode("div", _hoisted_79, [
                              _createVNode("div", null, [
                                _createVNode(_component_q_skeleton, {
                                  type: "text",
                                  style: {"width":"134px","margin-bottom":"4px","position":"relative","float":"right"}
                                })
                              ]),
                              _createVNode("div", _hoisted_80, [
                                _createVNode(_component_q_skeleton, {
                                  type: "text",
                                  style: {"width":"80px","margin-bottom":"4px"}
                                })
                              ])
                            ])
                          ]),
                          _createVNode("td", _hoisted_81, [
                            _createVNode("div", _hoisted_82, [
                              _createVNode(_component_q_skeleton, {
                                style: {"min-width":"80px","height":"30px","line-height":"37px","border-radius":"18px"},
                                type: "QAvatar"
                              }),
                              _createVNode(_component_q_skeleton, {
                                style: {"min-width":"80px","height":"30px","line-height":"37px","border-radius":"18px"},
                                type: "QAvatar"
                              })
                            ])
                          ])
                        ])
                      }), 64))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_q_page_scroller, {
              class: "scroller",
              position: "bottom-right",
              "scroll-offset": 450,
              offset: [18, 24]
            }, {
              default: _withId(() => [
                _createVNode(_component_q_btn, {
                  fab: "",
                  class: "scroller-btn"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_q_icon, {
                      class: "scroller-btn-icon",
                      name: "keyboard_arrow_up"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode("div", _hoisted_83, [
      _createVNode("div", _hoisted_84, [
        _createVNode(_component_SupplyAndBorrow, {
          "pool-type": _ctx.poolType,
          "page-type": "Bonfida"
        }, null, 8, ["pool-type"]),
        _createVNode("div", _hoisted_85, [
          _createVNode(_component_q_scroll_area, { style: {"height":"37px"} }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_86, [
                _createVNode("div", _hoisted_87, [
                  _createVNode("div", {
                    class: ["tab", {'tab-active-first': _ctx.poolType==='larix'}],
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.poolType='larix'))
                  }, "LARIX", 2),
                  _createVNode("div", {
                    class: ["tab", {'tab-active-i': _ctx.poolType==='stepn'}],
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.poolType='stepn'))
                  }, "Stepn", 2),
                  _createVNode("div", {
                    class: ["tab", {'tab-active-i': _ctx.poolType==='step'}],
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.poolType='step'))
                  }, "Step", 2),
                  _createVNode("div", {
                    class: ["tab", {'tab-active-i': _ctx.poolType==='xSol'}],
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.poolType='xSol'))
                  }, "xSOL", 2),
                  _createVNode("div", {
                    class: ["tab", {'tab-active-i': _ctx.poolType==='bonfida'}],
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.poolType='bonfida'))
                  }, "Bonfida", 2)
                ]),
                _createVNode("div", _hoisted_88, [
                  _createVNode("img", {
                    src: _ctx.noFee,
                    height: "14",
                    width: "14",
                    style: {"margin-right":"5px"}
                  }, null, 8, ["src"]),
                  _hoisted_89,
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.t('home.noBorrowFee')) + " ", 1),
                    _createVNode(_component_q_tooltip, { "hide-delay": 5000 }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('tip.borrowFeeTip')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          (!_ctx.isLoadingInfo)
            ? (_openBlock(), _createBlock("div", _hoisted_90, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortMarket(), (item, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "homeAppContainer-table-item",
                    key: item.id,
                    style: index===_ctx.sortMarket().length-1?'margin-bottom: 10px':''
                  }, [
                    _createVNode("div", _hoisted_91, [
                      _createVNode("div", _hoisted_92, [
                        _createVNode("img", {
                          style: {"margin-right":"10px"},
                          src: item.logoSource,
                          height: item.isLP?'34':'34',
                          width: item.isLP?'64':'34',
                          alt: ""
                        }, null, 8, ["src", "height", "width"]),
                        (!item.isLP)
                          ? (_openBlock(), _createBlock("div", _hoisted_93, [
                              _createVNode("div", null, _toDisplayString(item.fullName), 1),
                              _createVNode("span", _hoisted_94, "$" + _toDisplayString(_ctx.formatBigNumberStr(item.liquidityPrice,2)), 1)
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_95, [
                              _createVNode("div", null, _toDisplayString(item.symbol), 1),
                              _hoisted_96
                            ]))
                      ]),
                      _createVNode("div", _hoisted_97, [
                        _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(item.totalAvailableAmount,0)) + " " + _toDisplayString(item.symbol), 1),
                        _createVNode("span", _hoisted_98, _toDisplayString(_ctx.t('home.liquidity')), 1)
                      ])
                    ]),
                    _createVNode("div", _hoisted_99, [
                      _createVNode("div", _hoisted_100, [
                        _createTextVNode(_toDisplayString(_ctx.t('home.supplyAPY')) + " ", 1),
                        _createVNode("img", {
                          src: _ctx.icon_information,
                          width: "10",
                          height: "10",
                          style: {"margin-left":"4px","cursor":"pointer"}
                        }, null, 8, ["src"]),
                        (!item.isLP)
                          ? (_openBlock(), _createBlock(_component_q_tooltip, {
                              key: 0,
                              "hide-delay": 5000,
                              anchor: "top right",
                              self: "bottom right",
                              offset: [100,10]
                            }, {
                              default: _withId(() => [
                                _createVNode("p", _hoisted_101, _toDisplayString(_ctx.t('home.supplyAPY')) + " " + _toDisplayString(_ctx.formatBigNumberStr(item.supplyApy.times(100),2)) + "%", 1),
                                (item.hasSingleTokenDoubleReward)
                                  ? (_openBlock(), _createBlock("p", _hoisted_102, _toDisplayString(item.singleTokenDoubleRewardTokenSymbol) + " " + _toDisplayString(item.singleTokenDoubleRewardApy.times(100).toFixed(2)) + "%", 1))
                                  : _createCommentVNode("", true),
                                _createVNode("p", null, "+ " + _toDisplayString(_ctx.t('tip.larixRewards')) + " " + _toDisplayString(_ctx.formatBigNumberStr(item.supplyDistributionApy.times(100),2)) + "%", 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true),
                        (item.isLP)
                          ? (_openBlock(), _createBlock(_component_q_tooltip, {
                              key: 1,
                              "hide-delay": 5000,
                              anchor: "top right",
                              self: "bottom right",
                              offset: [100,10]
                            }, {
                              default: _withId(() => [
                                _createVNode("p", null, "Fees " + _toDisplayString(isNaN(item.lpInfo.lpFeesApr)?0:item.lpInfo.lpFeesApr) + "%", 1),
                                (item.lpInfo.rewardASymbol)
                                  ? (_openBlock(), _createBlock("p", _hoisted_103, _toDisplayString(item.lpInfo.rewardASymbol) + " " + _toDisplayString(item.lpInfo.lpRewardAprA.toFixed(2)) + "%", 1))
                                  : _createCommentVNode("", true),
                                (item.lpInfo.rewardBSymbol)
                                  ? (_openBlock(), _createBlock("p", _hoisted_104, _toDisplayString(item.lpInfo.rewardBSymbol) + " " + _toDisplayString(item.lpInfo.lpRewardAprB.toFixed(2)) + "%", 1))
                                  : _createCommentVNode("", true),
                                _createVNode("p", null, "+ " + _toDisplayString(_ctx.t('tip.larixRewards')) + " " + _toDisplayString(item.supplyDistributionApy.times(100).toFixed(2)) + "%", 1),
                                (item.lpInfo.doubleRewardSymbol&&item.lpInfo.doubleRewardApy.isGreaterThan(0))
                                  ? (_openBlock(), _createBlock("p", _hoisted_105, _toDisplayString(item.lpInfo.doubleRewardSymbol) + " " + _toDisplayString(_ctx.formatBigNumberStr(item.lpInfo.doubleRewardApy.times(100),2)) + "%", 1))
                                  : _createCommentVNode("", true),
                                (item.singleTokenDoubleRewardTokenSymbol&&item.singleTokenDoubleRewardApy?.isGreaterThan(0))
                                  ? (_openBlock(), _createBlock("p", _hoisted_106, _toDisplayString(_ctx.t('tip.doubleRewardTip',{x:item.singleTokenDoubleRewardTokenSymbol})), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      (!item.isLP)
                        ? (_openBlock(), _createBlock("div", _hoisted_107, _toDisplayString(_ctx.formatBigNumberStr(item.supplyApy.times(100).plus( item.supplyDistributionApy.times(100)).plus(item.singleTokenDoubleRewardApy.times(100)),2)) + "% ", 1))
                        : (_openBlock(), _createBlock("div", _hoisted_108, _toDisplayString(_ctx.formatBigNumberStr(item.lpInfo.lpApr.plus(item.lpInfo.doubleRewardApy.times(100)).plus(isNaN(item.lpInfo.lpFeesApr)?0:item.lpInfo.lpFeesApr).plus( item.supplyDistributionApy.times(100)),2)) + "% ", 1))
                    ]),
                    (!item.isLP)
                      ? (_openBlock(), _createBlock("div", _hoisted_109, [
                          _createVNode("div", _hoisted_110, [
                            _createTextVNode(_toDisplayString(_ctx.t('home.borrowAPY')) + " ", 1),
                            _createVNode("img", {
                              src: _ctx.icon_information,
                              width: "10",
                              height: "10",
                              style: {"margin-left":"4px","cursor":"pointer"}
                            }, null, 8, ["src"]),
                            _createVNode(_component_q_tooltip, {
                              "hide-delay": 5000,
                              anchor: "top right",
                              self: "bottom right",
                              offset: [100,10]
                            }, {
                              default: _withId(() => [
                                _createVNode("p", _hoisted_111, _toDisplayString(_ctx.t('home.borrowAPY')) + " " + _toDisplayString(_ctx.formatBigNumberStr(item.borrowApy.times(100),2)) + "%", 1),
                                _createVNode("p", null, "- " + _toDisplayString(_ctx.t('tip.larixRewards')) + " " + _toDisplayString(_ctx.formatBigNumberStr(item.borrowDistributionApy.times(100),2)) + "%", 1),
                                (item.singleTokenDoubleBorrowRewardApy)
                                  ? (_openBlock(), _createBlock("p", _hoisted_112, "- " + _toDisplayString(item.singleTokenDoubleRewardTokenSymbol) + " " + _toDisplayString(item.singleTokenDoubleBorrowRewardApy.toFixed(2)) + "%", 1))
                                  : _createCommentVNode("", true),
                                (item.singleTokenDoubleRewardTokenSymbol&&item.singleTokenDoubleBorrowRewardApy?.isGreaterThan(0))
                                  ? (_openBlock(), _createBlock("p", _hoisted_113, _toDisplayString(_ctx.t('tip.doubleRewardTip',{x:item.singleTokenDoubleRewardTokenSymbol})), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createVNode("div", null, _toDisplayString(_ctx.formatBigNumberStr(item.borrowApy.times(100).minus(item.borrowDistributionApy.times(100)).minus(item?.singleTokenDoubleBorrowRewardApy||0),2)) + "%", 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_114, [
                      _createVNode("div", _hoisted_115, _toDisplayString(_ctx.t('home.wallet')), 1),
                      _createVNode("div", null, _toDisplayString(item.userAssetDetails?_ctx.formatBigNumberStr(item.userAssetDetails.walletBalanceInTokenUnit,['soETH','ETH','BTC'].includes(item.symbol)||item.isLP?4:2):0) + " " + _toDisplayString(item.symbol), 1)
                    ]),
                    _createVNode("div", _hoisted_116, [
                      _createVNode("div", {
                        class: "link",
                        style: !item.isLP?' width: calc(100% - 165px);':'width: calc(100% - 84px);'
                      }, null, 4),
                      _createVNode("div", {
                        class: "button",
                        style: !item.isLP?' 165px;':' width:84px'
                      }, [
                        _createVNode("div", {
                          class: item.isLP?'lpButton':'',
                          onClick: ($event: any) => (_ctx.openSupplyMarketsDialog(item,'supply'))
                        }, _toDisplayString(_ctx.t('home.supply')), 11, ["onClick"]),
                        _createVNode(_component_q_btn, {
                          class: "operationButton",
                          "no-caps": "",
                          style: {"min-height":"30px","height":"30px","font-weight":"400","border-radius":"18px"},
                          onClick: ($event: any) => (_ctx.openBorrowMarketsDialog(item,'borrow'))
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('home.borrow')), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ], 4)
                    ])
                  ], 4))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.walletAddress!==''&&_ctx.isLoadingInfo)
            ? (_openBlock(), _createBlock("div", _hoisted_117, [
                _createVNode("div", _hoisted_118, [
                  _createVNode("div", _hoisted_119, [
                    _createVNode(_component_q_skeleton, { style: {"border-radius":"50%","margin-left":"4px","width":"34px","height":"34px"} }),
                    _createVNode("div", null, [
                      _createVNode(_component_q_skeleton, {
                        type: "text",
                        style: {"width":"54px","margin-bottom":"4px"}
                      }),
                      _createVNode(_component_q_skeleton, {
                        type: "text",
                        style: {"width":"54px","margin-bottom":"4px"}
                      })
                    ])
                  ]),
                  _createVNode("div", _hoisted_120, [
                    _createVNode(_component_q_skeleton, {
                      type: "text",
                      style: {"width":"80px","margin-bottom":"4px"}
                    }),
                    _createVNode(_component_q_skeleton, {
                      type: "text",
                      style: {"width":"54px","margin-bottom":"4px","float":"right"}
                    })
                  ])
                ]),
                _createVNode("div", _hoisted_121, [
                  _createVNode("div", _hoisted_122, [
                    _createVNode(_component_q_skeleton, {
                      type: "text",
                      style: {"width":"80px","margin-bottom":"4px"}
                    })
                  ]),
                  _createVNode("div", null, [
                    _createVNode(_component_q_skeleton, {
                      type: "text",
                      style: {"width":"54px","margin-bottom":"4px"}
                    })
                  ])
                ]),
                _createVNode("div", _hoisted_123, [
                  _createVNode("div", _hoisted_124, [
                    _createVNode(_component_q_skeleton, {
                      type: "text",
                      style: {"width":"80px","margin-bottom":"4px"}
                    })
                  ]),
                  _createVNode("div", null, [
                    _createVNode(_component_q_skeleton, {
                      type: "text",
                      style: {"width":"54px","margin-bottom":"4px"}
                    })
                  ])
                ]),
                _createVNode("div", _hoisted_125, [
                  _createVNode("div", _hoisted_126, [
                    _createVNode(_component_q_skeleton, {
                      type: "text",
                      style: {"width":"80px","margin-bottom":"4px"}
                    })
                  ]),
                  _createVNode("div", null, [
                    _createVNode(_component_q_skeleton, {
                      type: "text",
                      style: {"width":"54px","margin-bottom":"4px"}
                    })
                  ])
                ]),
                _createVNode("div", _hoisted_127, [
                  _hoisted_128,
                  _createVNode("div", _hoisted_129, [
                    _createVNode(_component_q_skeleton, {
                      type: "text",
                      style: {"width":"74px","height":"58px","border-radius":"20px","margin-left":"9px"}
                    }),
                    _createVNode(_component_q_skeleton, {
                      type: "text",
                      style: {"width":"74px","height":"58px","border-radius":"20px","margin-left":"8px"}
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_130
        ])
      ])
    ])
  ], 64))
})